import { useEffect } from "react";
import { BUSINESS, FAQS } from "@/content/site";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${BUSINESS.siteUrl}${path}`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = `${BUSINESS.siteUrl}${path}`;
  }, [title, description, path]);
  return null;
};

export const FaqSchema = () => {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "faq-schema";
    s.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
    document.head.appendChild(s);
    return () => { s.remove(); };
  }, []);
  return null;
};
